<template>
    <Header></Header>
    <NuxtLoadingIndicator color="repeating-linear-gradient(to right,#f3f2ed 0%,#000000 100%)" />
    <div class="pt-20 md:pt-24">
      <NuxtPage />
    </div>
    <Footer></Footer>

</template>

<script lang="js" setup>

onMounted(() => {
  useNuxtApp().$aos().init()
  window.onresize = function () {
    useNuxtApp().$aos().refresh()
  }
})
</script>